import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useDraggable } from '../../hooks/useDraggable';
import FormattedResponse from './FormattedResponse';

const FirstMessageModal = ({ firstMessage, onClose }) => {
  const { position, modalRef, startDrag } = useDraggable(100, 100);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div className="first-message-modal-overlay">
      <div
        className="first-message-modal"
        onClick={e => e.stopPropagation()}
        onMouseDown={startDrag}
        ref={modalRef}
        style={{ left: `${position.x}px`, top: `${position.y}px` }}
      >
        <div className="first-message-header">
          <button
            className="first-message-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="formatted-passage">
          <FormattedResponse response={firstMessage} />
        </div>
      </div>
    </div>
  );
};

export default FirstMessageModal;
